import { Text } from '@usealloy/component-library';
import { generateDuplicateEntitiesAndEvaluationsText } from '~/helpers/messages';

export const VelocityWarningText = ({
  duplicateEntitiesCount, duplicateEvaluationsCount, name, onDuplicatePiiClick,
}: {
  duplicateEntitiesCount: number;
  duplicateEvaluationsCount: number;
  name: string;
  onDuplicatePiiClick: () => void;
}) => (
  <Text
    size={1}
    lineHeight={2}
    style={{
      textAlign: 'center',
      color: 'var(--cl-text-accent)',
    }}
    onClick={onDuplicatePiiClick}
  >
    {`This ${name} has been used by`}
    <br />
    {generateDuplicateEntitiesAndEvaluationsText(
      duplicateEntitiesCount, duplicateEvaluationsCount,
    )}
  </Text>
);
